export type ThemePreference = 'system' | 'light' | 'dark';

export function readTheme(): ThemePreference {
  try {
    const stored = localStorage.getItem('pq-theme');
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(preference: ThemePreference): void {
  const dark = preference === 'dark' || (preference === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  try { localStorage.setItem('pq-theme', preference); } catch { /* storage can be disabled */ }
  window.dispatchEvent(new CustomEvent('pq-theme-change'));
}

